var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "icon-poster"
  }, /*#__PURE__*/React.createElement("g", {
    className: "icon-style"
  }, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    stroke: "white",
    fill: "white",
    points: "16,26 32,21 48,26 48,38 40,44 32,46 24,44 16,38 16,26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282D37",
    fillRule: "non-zero",
    d: "M52.945 18.674a1 1 0 0 1-.618 1.271c-1.745.603-3.001 2.714-3.241 4.655-.045.34-.072.683-.081 1.03l-.003.349v10.366c2.208-2.734 3.949-6 5.04-9.633a1 1 0 0 1 1.916.576c-1.434 4.768-3.92 8.961-7.109 12.24a.999.999 0 0 1-.313.317l-.24.237C43.84 44.408 38.113 47 32 47c-6.225 0-12.048-2.688-16.537-7.157a1 1 0 0 1-.312-.314c-3.189-3.28-5.675-7.473-7.108-12.24a1 1 0 0 1 1.915-.577c1.092 3.633 2.832 6.9 5.042 9.634v-6.168l-.001-.032V26.18a9.765 9.765 0 0 0-.084-1.367 4.98 4.98 0 0 0-3.253-4.018 1 1 0 0 1 .676-1.881 6.98 6.98 0 0 1 4.52 5.376c.134-.068.274-.125.42-.173l13.72-3.975a3.609 3.609 0 0 1 1.757-.062l.247.062 13.518 3.915c.207.055.405.128.593.219l-.01.07c.323-2.613 1.98-5.395 4.572-6.29a1 1 0 0 1 1.271.618zm-21.214 3.349l-.176.04-13.56 3.927c-.533.141-.92.593-.985 1.116l-.01.132V38.55C21.115 42.588 26.395 45 32 45c5.606 0 10.886-2.412 15-6.45V27.257a1.34 1.34 0 0 0-.88-1.23l-.136-.043-13.537-3.92a1.609 1.609 0 0 0-.716-.041z",
    className: "base"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC0016",
    d: "M43.767 33.358a1 1 0 0 1-.124 1.409 18.125 18.125 0 0 1-23.285 0 1 1 0 1 1 1.285-1.533 16.125 16.125 0 0 0 20.715 0 1 1 0 0 1 1.409.124zM38.8 27.4a1 1 0 0 1-.2 1.4 11 11 0 0 1-13.2 0 1 1 0 0 1 1.2-1.6 9 9 0 0 0 10.8 0 1 1 0 0 1 1.4.2z",
    className: "pulse"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.69e70b30554946c943a0d4bf350732a7.svg";
export { ForwardRef as ReactComponent };